import clsx from 'clsx';
import KeyboardIcon from 'ui/SVG/KeyboardIcon';
import SectionFrameIcon from 'ui/SVG/SectionFrameIcon';
import Title from './elements/Title';
import './ContentFrame.scss';

interface ContentFrameProps {
  className?: string;
  borders?: boolean;
  title?: string;
  children?: React.ReactNode;
}

const ContentFrame: React.FC<ContentFrameProps> = ({ className, borders, title, children }) => {
  return (
    <div className={clsx('content-frame', { borders }, className)}>
      <div className="content-frame__wrapper">
        <div className="content-frame__background">
          <SectionFrameIcon className="content-frame__frame" />
          <Title title={title} />
          <KeyboardIcon className="content-frame__keyboard" />
        </div>
        <div className="content-frame__content">{children}</div>
      </div>
    </div>
  );
};

export default ContentFrame;
